import { countCards } from './moveConstants';

function commonHandle(moves, rivalMove) {
    return moves.filter((move) => move[0] > rivalMove[0]);
}

export function filterType1Single(moves, rivalMove) {
    return commonHandle(moves, rivalMove);
}

export function filterType2Pair(moves, rivalMove) {
    return commonHandle(moves, rivalMove);
}

export function filterType3Triple(moves, rivalMove) {
    return commonHandle(moves, rivalMove);
}

export function filterType4Bomb(moves, rivalMove) {
    return commonHandle(moves, rivalMove);
}

export function filterType6_3_1(moves, rivalMove) {
    const rival = [...rivalMove].sort((a, b) => a - b);
    const rivalRank = rival[1];
    return moves.filter((move) => {
        const sorted = [...move].sort((a, b) => a - b);
        return sorted[1] > rivalRank;
    });
}

export function filterType7_3_2(moves, rivalMove) {
    const rival = [...rivalMove].sort((a, b) => a - b);
    const rivalRank = rival[2];
    return moves.filter((move) => {
        const sorted = [...move].sort((a, b) => a - b);
        return sorted[2] > rivalRank;
    });
}

export function filterType8SerialSingle(moves, rivalMove) {
    return commonHandle(moves, rivalMove);
}

export function filterType9SerialPair(moves, rivalMove) {
    return commonHandle(moves, rivalMove);
}

export function filterType10SerialTriple(moves, rivalMove) {
    return commonHandle(moves, rivalMove);
}

export function filterType11Serial3_1(moves, rivalMove) {
    const rival = countCards(rivalMove);
    const rivalRank = Math.max(...Object.keys(rival).map(Number).filter((k) => rival[k] === 3));
    return moves.filter((move) => {
        const mymove = countCards(move);
        const myRank = Math.max(...Object.keys(mymove).map(Number).filter((k) => mymove[k] === 3));
        return myRank > rivalRank;
    });
}

export function filterType12Serial3_2(moves, rivalMove) {
    const rival = countCards(rivalMove);
    const rivalRank = Math.max(...Object.keys(rival).map(Number).filter((k) => rival[k] === 3));
    return moves.filter((move) => {
        const mymove = countCards(move);
        const myRank = Math.max(...Object.keys(mymove).map(Number).filter((k) => mymove[k] === 3));
        return myRank > rivalRank;
    });
}

export function filterType13_4_2(moves, rivalMove) {
    const rival = [...rivalMove].sort((a, b) => a - b);
    const rivalRank = rival[2];
    return moves.filter((move) => {
        const sorted = [...move].sort((a, b) => a - b);
        return sorted[2] > rivalRank;
    });
}

export function filterType14_4_22(moves, rivalMove) {
    const rival = countCards(rivalMove);
    let rivalRank = 0;
    Object.entries(rival).forEach(([k, v]) => {
        if (v === 4) rivalRank = Number(k);
    });
    return moves.filter((move) => {
        const mymove = countCards(move);
        let myRank = 0;
        Object.entries(mymove).forEach(([k, v]) => {
            if (v === 4) myRank = Number(k);
        });
        return myRank > rivalRank;
    });
}
